import React from 'react';
import { NavLink } from 'react-router-dom';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import sidebarLinks from '../helpers/sidebarLinks';

const AssetsSidebarList = ({ expanded }) => {
  if (!expanded) {
    return null;
  }
  return (
    <>
      {sidebarLinks.map((group) => (
        <div key={group.path} className="flex flex-col">
          <NavLink
            data-qa={`${group.name}`}
            name={group.name}
            end={group.end ? group.end : false}
            to={group.path}
            className={({ isActive }) =>
              cn(
                'm-0  flex cursor-pointer items-center gap-2 rounded-[4px] !px-3 !py-2 text-sm leading-5',
                isActive
                  ? 'bg-primary-50 text-primary-500 hover:text-primary-500'
                  : 'bg-white text-neutral-800  hover:!bg-neutral-100 hover:text-neutral-800'
              )
            }>
            {group?.icon && <Icon icon={group.icon} />}
            {group.name}
          </NavLink>
        </div>
      ))}
    </>
  );
};

export default AssetsSidebarList;
